// extracted by mini-css-extract-plugin
export default {"page":"OR","headerwrap":"PR","headerblock":"QR","textwrapper":"RR","text":"SR","closerlook":"TR","arrowwrap":"UR","icon":"VR","updown":"WR","products":"XR","system":"YR","systemimage":"ZR","cards":"aS","note":"bS","fadein":"cS"};
    if(module.hot) {
      // 1714422956955
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  